import { Apis } from "libs/apis";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes.enums";
import { messaging } from "../../../firebase/firebase.config";
import { getToken } from "firebase/messaging";

export default function useLogin() {
  const navigate = useNavigate();

  const login = async (body: any, onSuccess: () => void, onError: (message: string) => void) => {
    try {
      const res = await Apis.login(body);

      let userRole = null;

      if (res.data.userRole) {
        userRole = res.data.userRole;
      } else if (res.data.data && res.data.data.userRole) {
        userRole = res.data.data.userRole;
      } else if (res.data.user && res.data.user.userRole) {
        userRole = res.data.user.userRole;
      }
      if (userRole !== "admin") {
        onError("Access denied. Only admin users can login to this panel.");
        return;
      }

      localStorage.removeItem("tempEmail");
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("adminProfile", JSON.stringify(res.data));

      const requestPermission = async () => {
        try {
          const permission = await Notification.requestPermission();

          if (permission === "granted") {
            const token = await getToken(messaging, {
              vapidKey: process.env.REACT_APP_Fire_BASE_VAPID_KEY,
            });

            if (token) {
              try {
                const userFcmToken = res.data.fcmToken;

                if (userFcmToken !== token) {
                  const body = {
                    fcmToken: token,
                  };

                  await Apis.saveFcm(body);
                } else {
                }
              } catch (error) {
                console.error(
                  "Failed to update FCM token on the backend",
                  error
                );
              }
            } else {
            }
          } else {
          }
        } catch (error) {
          console.error(
            "Error while requesting permission or getting token:",
            error
          );
        }
      };

      if (res.data.status) {
        requestPermission();
        onSuccess();
        navigate(siteRoutes.dashboard);
      }
    } catch (error) {
      console.error("Login failed", error);
      onError("Login failed. Please check your credentials and try again.");
    }
  };

  return { login };
}
